export const queryKeys = {
  getCampaignContributionReportData: "getCampaignContributionReportData",
  getCampaignContributionReportLookups: "getCampaignContributionReportLookups",
};
